export default __webpack_public_path__ + "static/media/crosseye.a7b712e6.svg";